export function scrollToAnchor(anchor: string, offset = 0): void {
    if (!anchor) return;
    history.pushState(null, '', `#${anchor}`);
    const id = anchor.replace('#', '');
    const target = document.getElementById(id);
    const header = document.querySelector('header');
    const headerHeight = header ? header.getBoundingClientRect().height : 0;
    if (target) {
        scroll({
            top: target.getBoundingClientRect().top + window.scrollY - offset - headerHeight,
            behavior: 'smooth',
        });
    }
}

export function hidePlaceholderTextArea(el: HTMLElement): void {
    const textArea = el.parentElement?.parentElement?.querySelector('.textArea') as HTMLTextAreaElement|null;
    if (textArea) {
        if (el.scrollTop > 0) {
            textArea.style.display = "none";
        } else {
            textArea.style.display = "block";
        }
    }
}

export function limitInputLength(el: Node, maxLength = -1): void {
    if (!(el instanceof HTMLInputElement) || maxLength <= 0) {
        return;
    }

    const id = el.id;
    const form = el.closest('form');
    if (!id || !form) {
        return;
    }

    const lengthControlElement = form.querySelector(`[data-js-length-control="${id}"]`);
    if (!lengthControlElement) {
        return;
    }

    const length = el.value.length;
    lengthControlElement.textContent = length + '/' + maxLength;
    if (length >= maxLength) {
        lengthControlElement.classList.add('text-secondary-02')
    } else {
        lengthControlElement.classList.remove('text-secondary-02')
    }
}
